var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpeakIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 49,
    viewBox: "0 0 38 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0625 28.425C11.7632 28.425 7.45 24.1118 7.45 18.8125C7.45 13.5132 11.7632 9.2 17.0625 9.2C22.3618 9.2 26.675 13.5132 26.675 18.8125C26.675 24.1118 22.3618 28.425 17.0625 28.425ZM17.0625 13.3313C14.0401 13.3313 11.5813 15.7901 11.5813 18.8125C11.5813 21.8349 14.0401 24.2937 17.0625 24.2937C20.0849 24.2937 22.5437 21.8349 22.5437 18.8125C22.5437 15.7901 20.0849 13.3313 17.0625 13.3313Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 0.9
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9469 48.55C28.8663 48.55 27.9688 47.6457 27.9688 46.5063V41.5188C27.9688 38.9907 25.9623 36.9125 23.4719 36.9125H8.90312C6.41272 36.9125 4.40625 38.9907 4.40625 41.5188V46.5063C4.40625 47.6457 3.50868 48.55 2.42812 48.55C1.34757 48.55 0.45 47.6457 0.45 46.5063V41.5188C0.45 36.7119 4.2516 32.825 8.90312 32.825H23.4719C28.1234 32.825 31.925 36.7119 31.925 41.5188V46.5063C31.925 47.6457 31.0274 48.55 29.9469 48.55Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 0.9
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8409 24.7998C29.2351 25.0437 29.7545 24.9311 29.9853 24.529C31.168 22.4688 31.7784 20.1408 31.749 17.774C31.7195 15.4067 31.0511 13.0931 29.8169 11.0607C29.5765 10.6649 29.0552 10.565 28.6673 10.8179C28.263 11.0816 28.1593 11.626 28.4045 12.0418C29.436 13.7911 29.9941 15.7703 30.0193 17.7942C30.0444 19.818 29.5358 21.8094 28.5484 23.5821C28.3135 24.0039 28.4302 24.5457 28.8409 24.7998Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0692 27.6209C34.61 27.9748 35.3393 27.8162 35.6456 27.2471C37.1402 24.4703 37.9112 21.3378 37.8737 18.1535C37.8362 14.9699 36.9921 11.8579 35.4331 9.1191C35.1131 8.55701 34.3795 8.41593 33.8471 8.7831C33.3312 9.13886 33.198 9.8397 33.5046 10.3862C34.8336 12.7546 35.5529 15.4377 35.5852 18.1818C35.6174 20.9261 34.9614 23.6264 33.6884 26.027C33.3948 26.5806 33.5449 27.2779 34.0692 27.6209Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeakIcon);
export default __webpack_public_path__ + "static/media/speakIcon.560d0f337c2b21a1245d32bdef1d1ee2.svg";
export { ForwardRef as ReactComponent };